<template>
  <!-- Chat Widget — visual presence only, mimics original float button -->
  <button
    class="chat-widget"
    :class="{ 'widget-visible': true, 'widget-breathe': true }"
    aria-label="Chat support"
  >
    <svg class="widget-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm3 6h10a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2zm0 4h7a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2z"/>
    </svg>
    <span class="widget-badge micro-pulse">1</span>
  </button>
</template>

<script>
export default {
  name: 'ChatWidget',
}
</script>

<style scoped>
.chat-widget {
  position: fixed;
  bottom: 90px;
  right: 16px;
  z-index: 999;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background: var(--brand-gradient);
  box-shadow: 0 4px 20px rgba(91,127,255,0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.chat-widget:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 28px rgba(91,127,255,0.6);
}
.widget-icon {
  width: 24px;
  height: 24px;
  fill: #fff;
}
.widget-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: #ef4444;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 2px 6px rgba(239,68,68,0.4);
}
.widget-breathe {
  animation: widget-breathing 3s ease-in-out infinite;
}
@keyframes widget-breathing {
  0%, 100% { box-shadow: 0 4px 20px rgba(91,127,255,0.4); }
  50%      { box-shadow: 0 4px 28px rgba(91,127,255,0.7); }
}
</style>
